__webpack_require__.p = "#{CloudCdnEndPoint}/#{CloudBlob.Environment.ShortName}/#{Azure.Blob.ElysiumAppPathSegment}/#{Octopus.Release.Number}/_next/";